import api from "./api";

export default {
  getAll: (params = {}) => api.get("/pedidos", { params }),
  getById: (id) => api.get(`/pedidos/${id}`),
  create: (data) => api.post("/pedidos", { pedido: data }),
  update: (id, data) => api.put(`/pedidos/${id}`, { pedido: data }),
  destroy: (id) => api.delete(`/pedidos/${id}`),
  baixarEstoqueMateriais: (id) =>
    api.post(`/pedidos/${id}/baixar_estoque_materiais`),
  recalcularReservas: () => api.post("/pedidos/recalcular_reservas"),
};
